export default {"src":"https://webcdn.trailways.com/_next/static/media/close.1d96e89b.svg","height":17,"width":17,"blurWidth":0,"blurHeight":0};